/* ==========================================================================
   Pickle Kitchen — pk-global.js
   Header scroll-blur enhancement, hero slider, utility bar rotator,
   and scroll-reveal animation, ported from the approved mockup.
   All motion is gated behind prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Utility bar message rotation ---------- */
  document.querySelectorAll('.pk-utility-bar').forEach(function (bar) {
    var msgs = bar.querySelectorAll('.msg');
    if (!msgs.length || reduceMotion) return;
    var idx = 0;
    setInterval(function () {
      msgs[idx].classList.remove('active');
      idx = (idx + 1) % msgs.length;
      msgs[idx].classList.add('active');
    }, 4000);
  });

  /* ---------- Dawn sticky header: background blur once scrolled ---------- */
  (function () {
    var headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;
    var ticking = false;

    function onScroll() {
      if (window.scrollY > 4) {
        headerWrapper.classList.add('pk-scrolled');
      } else {
        headerWrapper.classList.remove('pk-scrolled');
      }
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(onScroll);
          ticking = true;
        }
      },
      { passive: true }
    );
    onScroll();
  })();

  /* ---------- Hero slider(s) ---------- */
  document.querySelectorAll('.pk-hero').forEach(function (hero) {
    var track = hero.querySelector('.pk-hero-track');
    var slides = hero.querySelectorAll('.pk-slide');
    var dots = hero.querySelectorAll('.pk-hero-dot');
    var prevBtn = hero.querySelector('.pk-hero-arrow.prev');
    var nextBtn = hero.querySelector('.pk-hero-arrow.next');
    var pauseBtn = hero.querySelector('.pk-hero-pause');
    var total = slides.length;
    if (!track || !total) return;

    var current = 0;
    var interval = null;
    var intervalTime = 5000;
    var paused = reduceMotion;

    if (pauseBtn && reduceMotion) {
      pauseBtn.classList.add('paused');
      pauseBtn.setAttribute('aria-pressed', 'true');
      pauseBtn.setAttribute('aria-label', 'Play carousel');
    }

    function updateDark(i) {
      var el = slides[i];
      var isDark = el && el.getAttribute('data-dark') === 'true';
      hero.classList.toggle('on-dark', !!isDark);
    }

    function goTo(i) {
      current = (i + total) % total;
      track.style.transform = 'translateX(-' + current * (100 / total) + '%)';
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === current);
      });
      dots.forEach(function (d, idx) {
        d.classList.toggle('active', idx === current);
      });
      updateDark(current);
    }

    function next() {
      goTo(current + 1);
    }
    function prev() {
      goTo(current - 1);
    }

    function startAuto() {
      if (reduceMotion || paused || total < 2) return;
      stopAuto();
      interval = setInterval(next, intervalTime);
    }
    function stopAuto() {
      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    }

    function setPaused(next) {
      paused = next;
      if (paused) {
        stopAuto();
      } else {
        startAuto();
      }
      if (pauseBtn) {
        pauseBtn.classList.toggle('paused', paused);
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Play carousel' : 'Pause carousel');
      }
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.getAttribute('data-goto'), 10));
        if (!paused) startAuto();
      });
    });
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        if (!paused) startAuto();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        if (!paused) startAuto();
      });
    }
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        setPaused(!paused);
      });
    }

    hero.addEventListener('mouseenter', stopAuto);
    hero.addEventListener('mouseleave', function () {
      if (!paused) startAuto();
    });

    /* touch swipe — ignore vertical/scroll gestures (|dy| > |dx|) */
    var touchStartX = 0,
      touchEndX = 0,
      touchStartY = 0,
      touchEndY = 0;
    hero.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        stopAuto();
      },
      { passive: true }
    );
    hero.addEventListener(
      'touchend',
      function (e) {
        touchEndX = e.changedTouches[0].screenX;
        touchEndY = e.changedTouches[0].screenY;
        var dx = touchEndX - touchStartX;
        var dy = touchEndY - touchStartY;
        if (Math.abs(dy) <= Math.abs(dx) && Math.abs(dx) > 40) {
          if (dx < 0) next();
          else prev();
        }
        if (!paused) startAuto();
      },
      { passive: true }
    );

    goTo(0);
    startAuto();
  });

  /* ---------- Scroll reveal with staggered children ---------- */
  (function () {
    var items = document.querySelectorAll('.pk-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      items.forEach(function (el) {
        el.classList.add('in-view');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var children = el.children;
            if (children.length) {
              Array.prototype.forEach.call(children, function (child, i) {
                child.style.transitionDelay = i * 45 + 'ms';
              });
            }
            el.classList.add('in-view');
            io.unobserve(el);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    items.forEach(function (el) {
      io.observe(el);
    });
  })();
})();
